import { Link } from 'gatsby'
import React, { Component } from 'react'
import * as R from 'ramda'
import './style.scss'

class Nav extends Component {
  constructor(props) {
    super(props)
    // Initialize with a value that shows desktop nav (SSR-safe default)
    // CSS will handle hiding on mobile via media queries
    this.state = { width: 1024, height: 768, mounted: false }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
  }

  componentDidMount() {
    this.setState({ mounted: true })
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions() {
    if (typeof window !== 'undefined') {
      this.setState({ width: window.innerWidth, height: window.innerHeight })
    }
  }

  render() {
    const sorter = R.sortBy(R.path(['node', 'acf', 'order']))
    const items = sorter(this.props.posts)
    // Always render desktop nav, CSS will handle responsive hiding
    const isDesktop = !this.state.mounted || this.state.width >= 800
    return (
      <div>
        {isDesktop ? (
          <nav className="navContainer desktopNav">
            <ul>
              <li>
                <Link
                  to={`/`}
                  className={this.props.current === '1' ? `current` : null}
                  aria-label="Etusivu"
                >
                  Etusivu
                </Link>
              </li>
              {items.map(item => {
                return (
                  <li key={item.node.id}>
                    <Link
                      to={`/${item.node.slug}/`}
                      className={
                        this.props.current === item.node.acf.order
                          ? `current`
                          : null
                      }
                      aria-label={item.node.title}
                    >
                      {item.node.title}
                    </Link>
                  </li>
                )
              })}
            </ul>
          </nav>
        ) : null}
      </div>
    )
  }
}
export default Nav
